import React from 'react';
import AiDisclaimer from './AiDisclaimer';

const GRADE_CLASS = {
  A: 'draft-grade--a',
  B: 'draft-grade--b',
  C: 'draft-grade--c',
  D: 'draft-grade--d',
  F: 'draft-grade--f',
};

/**
 * Renders per-team letter grades + reasoning for a completed draft (G1), plus an overall summary.
 *
 * @param {Object}   props
 * @param {Array}    props.teams          - Array of { slotIndex, teamName, letterGrade, reasoning }
 * @param {string}   props.overallSummary - 2-3 sentence summary of the draft as a whole
 * @param {string}   props.dataAsOf       - ISO timestamp for AiDisclaimer
 * @param {Function} [props.onClose]      - Optional close handler
 */
export default function DraftGrades({ teams, overallSummary, dataAsOf, onClose }) {
  return (
    <div className="ai-suggestion-panel">
      <div className="ai-suggestion-panel-header">
        <span className="ai-suggestion-panel-title">✦ Draft Grades</span>
        {onClose && (
          <button className="ai-suggestion-panel-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        )}
      </div>

      {overallSummary && <p className="draft-grades-summary">{overallSummary}</p>}

      <ul className="draft-grades-list">
        {teams.map((team) => {
          const gradeKey = (team.letterGrade || '').charAt(0).toUpperCase();
          return (
            <li key={team.slotIndex} className="draft-grades-item">
              <div className="draft-grades-item-header">
                <span className="draft-grades-team-name">{team.teamName}</span>
                <span className={`draft-grade-badge ${GRADE_CLASS[gradeKey] || ''}`}>
                  {team.letterGrade}
                </span>
              </div>
              {team.reasoning && <p className="draft-grades-reasoning">{team.reasoning}</p>}
            </li>
          );
        })}
      </ul>

      <AiDisclaimer dataAsOf={dataAsOf} />
    </div>
  );
}
